/**
 * Listings–product_suppliers links: get by listing_id for Update listing page.
 */
import axios from 'axios';
import { authHeaders } from './apiAuth';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

/**
 * Get listing_product_supplier rows, optionally filtered by listing_id and/or products_suppliers_id.
 * @param {string} accessToken - User's JWT
 * @param {{ listing_id?: number, products_suppliers_id?: number }} [params]
 * @returns {Promise<{ success: boolean, listing_product_suppliers?: Array<object>, error?: string }>}
 */
export const getListingProductSuppliers = async (accessToken, params = {}) => {
  try {
    const queryParams = new URLSearchParams();
    if (params.listing_id != null) queryParams.set('listing_id', String(params.listing_id));
    if (params.products_suppliers_id != null) queryParams.set('products_suppliers_id', String(params.products_suppliers_id));
    const url = `${API_BASE_URL}/api/listings-product-suppliers${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
    const response = await axios.get(url, { headers: authHeaders(accessToken) });
    return response.data;
  } catch (error) {
    const detail = error.response?.data?.detail;
    const message = typeof detail === 'string' ? detail : detail?.message || 'Failed to get listing product suppliers';
    throw new Error(message);
  }
};
